var map = {
	"./astonished.svg": 1730,
	"./avocado.svg": 1731,
	"./backhand-index-pointing-down.svg": 1732,
	"./backhand-index-pointing-right.svg": 1733,
	"./bank.svg": 1734,
	"./bearded-person.svg": 1735,
	"./bento-box.svg": 1736,
	"./bicycle.svg": 1737,
	"./blue-heart.svg": 1738,
	"./bust-in-silhouette.svg": 1739,
	"./calendar.svg": 1740,
	"./classical-building.svg": 1741,
	"./clipboard.svg": 1742,
	"./confused-face.svg": 1743,
	"./cookie.svg": 1744,
	"./cooking.svg": 1745,
	"./credit-card.svg": 1746,
	"./credit-cards.svg": 1747,
	"./crying-face.svg": 1748,
	"./curry-rice.svg": 1749,
	"./dancers.svg": 1750,
	"./detective.svg": 1751,
	"./envelope.svg": 1752,
	"./euro-banknote.svg": 1753,
	"./eyes-bg.svg": 1754,
	"./eyes-center.svg": 1755,
	"./eyes.svg": 1756,
	"./face-savouring-delicious-food.svg": 1757,
	"./face-screaming-in-fear.svg": 1758,
	"./face-with-stuck-out-tongue.svg": 1759,
	"./female-sign.svg": 1760,
	"./fire.svg": 1761,
	"./flexed-biceps.svg": 1762,
	"./folded-hands-light-skin-tone.svg": 1763,
	"./gem-stone.svg": 1764,
	"./green-salad.svg": 1765,
	"./hamburger.svg": 1766,
	"./hourglass-with-flowing-sand.svg": 1767,
	"./house-with-garden.svg": 1768,
	"./hugging-face.svg": 1769,
	"./inbox-tray.svg": 1770,
	"./key.svg": 1771,
	"./light-bulb.svg": 1772,
	"./love-letter.svg": 1773,
	"./love-you-gesture-light-skin-tone.svg": 1774,
	"./lunchr-card.svg": 1775,
	"./man-cook-light-skin-tone.svg": 1776,
	"./man-gesturing-no-light-skin-tone.svg": 1777,
	"./man-light-skin-tone.svg": 1778,
	"./man-shrugging-light-skin-tone.svg": 1779,
	"./man-shrugging.svg": 1780,
	"./man-technologist-light-skin-tone.svg": 1781,
	"./mobile-phone.svg": 1782,
	"./money-bag.svg": 1783,
	"./money-with-wings.svg": 1784,
	"./nerd-face.svg": 1785,
	"./office-building.svg": 1786,
	"./ok-hand.svg": 1787,
	"./open-mailbox-with-raised-flag.svg": 1788,
	"./package.svg": 1789,
	"./padlock.svg": 1790,
	"./page-facing-up.svg": 1791,
	"./page-with-curl.svg": 1792,
	"./party-popper.svg": 1793,
	"./pizza.svg": 1794,
	"./pray.svg": 1795,
	"./pretzel.svg": 1796,
	"./raised-hand-with-fingers-splayed-light-skin-tone.svg": 1797,
	"./raised-hand.svg": 1798,
	"./raising-hands.svg": 1799,
	"./red-heart.svg": 1800,
	"./relieved-face.svg": 1801,
	"./rocket.svg": 1802,
	"./sandwich.svg": 1803,
	"./seedling.svg": 1804,
	"./shortcake.svg": 1805,
	"./slightly-smiling-face.svg": 1806,
	"./smiling-face-with-heart-eyes.svg": 1807,
	"./smiling-face-with-open-mouth-cold-sweat.svg": 1808,
	"./smiling-face-with-open-mouth.svg": 1809,
	"./smiling-face-with-smiling-eyes.svg": 1810,
	"./smirking-face.svg": 1811,
	"./spiral-calendar.svg": 1812,
	"./star-struck.svg": 1813,
	"./star.svg": 1814,
	"./steaming-bowl.svg": 1815,
	"./stopwatch.svg": 1816,
	"./sun.svg": 1817,
	"./sunglasses.svg": 1818,
	"./sushi.svg": 1819,
	"./swile-card.svg": 1820,
	"./taco.svg": 1821,
	"./telephone-receiver.svg": 1822,
	"./telephone.svg": 1823,
	"./thinking-face.svg": 1824,
	"./thumbs-up.svg": 1825,
	"./timer-clock.svg": 1826,
	"./trophy.svg": 1827,
	"./vouchers.svg": 1828,
	"./warning.svg": 1829,
	"./waving-hand-light-skin-tone.svg": 1830,
	"./waving-hand.svg": 1831,
	"./white-heavy-check-mark.svg": 1832,
	"./white-medium-star.svg": 1833,
	"./winking-face.svg": 1834,
	"./woman-in-lotus-position.svg": 1835,
	"./woman-running.svg": 1836,
	"./woman.svg": 1837
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1729;